<template>
  <section class="section background-black is-medium">
    <div class="container">
      <h1 class="title is-1 has-text-weight-bold has-text-light">Our trainers</h1>
      <p
        class="has-text-grey"
      >We have ateam of world-class Pro MMA trainers each having an experience of 10 years in MMA</p>
      <br />
      <div class="columns scrolling-wrapper">
        <div
          class="column card drop-shadow has-text-centered"
          v-for="(trainer, index) in trainers"
          :key="index"
        >
          <figure class="image is-128x128">
            <img class="is-rounded" :src="trainer.img" />
          </figure>
          <br />
          <p class="subtitle is-6 has-text-grey-lighter is-capitalised">{{trainer.name}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      trainers: [
        {
          name: "Dipankar bajaj",
          desc: "Learn Basics of Boxing in 60 days",
          popular: true,
          img: require("@/assets/trainers/dipankar.png")
        },
        {
          name: "Aakash Kashyap",
          desc: "Start Boxing asap",
          img: require("@/assets/trainers/aakash.png")
        },
        {
          name: "Amit Prajapati",
          desc: "Start Boxing asap",
          img: require("@/assets/trainers/amit.png")
        },
        {
          name: "Kapil Gupta",
          desc: "MMA Introduction",
          img: require("@/assets/trainers/kapil.png")
        },
        {
          name: "Mohammad Rustam",
          desc: "Start Boxing asap",
          img: require("@/assets/trainers/mohammad.png")
        },
        {
          name: "Parmesh Manni",
          desc: "Start Boxing asap",
          img: require("@/assets/trainers/parmesh.png")
        },
        {
          name: "Gokul Nair",
          desc: "Start Boxing asap",
          img: require("@/assets/trainers/gokul.png")
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.scrolling-wrapper {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  .card {
    flex: 0 0 auto;
    padding: 20px;
    margin: 10px;
    height: 200px;
    width: 145px;
    background-color: transparent;
    color: whitesmoke;
  }
}

.card {
  display: inline-block;
  padding: 20px;
  margin: 10px;
  height: 200px;
  width: 145px !important;
  background-color: transparent;
  color: whitesmoke;
}

.scrolling-wrapper {
  -webkit-overflow-scrolling: touch;
}

.scrolling-wrapper {
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>